import { loadState } from '@nextcloud/initial-state';
import { translate as t, translatePlural as n } from '@nextcloud/l10n';
import Vue from 'vue';
import DeclarativeSection from './components/DeclarativeSettings/DeclarativeSection.vue';
const forms = loadState('settings', 'declarative-settings-forms', []);
console.debug('Loaded declarative forms:', forms);
/**
 *
 * @param forms
 */
function renderDeclarativeSettingsSections(forms) {
    Vue.mixin({ methods: { t, n } });
    const DeclarativeSettingsSection = Vue.extend(DeclarativeSection);
    return forms.map((form) => {
        const el = `#${form.app}_${form.id}`;
        return new DeclarativeSettingsSection({
            el,
            propsData: {
                form,
            },
        });
    });
}
document.addEventListener('DOMContentLoaded', () => {
    renderDeclarativeSettingsSections(forms);
});
